"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function get() {
    return _arrowRight["default"];
  }
});

_Object$defineProperty(exports, "ArrowRightWhite", {
  enumerable: true,
  get: function get() {
    return _arrowRightWhite["default"];
  }
});

_Object$defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _cal["default"];
  }
});

_Object$defineProperty(exports, "CloseFullpagePopup", {
  enumerable: true,
  get: function get() {
    return _closeFullpagePopup["default"];
  }
});

_Object$defineProperty(exports, "DruvaLogo", {
  enumerable: true,
  get: function get() {
    return _druvaLogo["default"];
  }
});

_Object$defineProperty(exports, "DruvaLogoOrange", {
  enumerable: true,
  get: function get() {
    return _druvaLogoOrange["default"];
  }
});

_Object$defineProperty(exports, "GlobalMenu", {
  enumerable: true,
  get: function get() {
    return _globalMenu["default"];
  }
});

_Object$defineProperty(exports, "GlobalMenuHover", {
  enumerable: true,
  get: function get() {
    return _globalMenuHover["default"];
  }
});

_Object$defineProperty(exports, "GreenTick", {
  enumerable: true,
  get: function get() {
    return _greenTick["default"];
  }
});

_Object$defineProperty(exports, "Hamburger", {
  enumerable: true,
  get: function get() {
    return _hamburger["default"];
  }
});

_Object$defineProperty(exports, "Help", {
  enumerable: true,
  get: function get() {
    return _help["default"];
  }
});

_Object$defineProperty(exports, "MenuClose", {
  enumerable: true,
  get: function get() {
    return _menuClose["default"];
  }
});

_Object$defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _search["default"];
  }
});

_Object$defineProperty(exports, "Sort", {
  enumerable: true,
  get: function get() {
    return _sort["default"];
  }
});

_Object$defineProperty(exports, "UserProfile", {
  enumerable: true,
  get: function get() {
    return _userProfile["default"];
  }
});

_Object$defineProperty(exports, "WizardArrow", {
  enumerable: true,
  get: function get() {
    return _wizardArrow["default"];
  }
});

var _arrowRight = _interopRequireDefault(require("../assets/icons/arrow-right.svg"));

var _arrowRightWhite = _interopRequireDefault(require("../assets/icons/arrow-right-white.svg"));

var _closeFullpagePopup = _interopRequireDefault(require("../assets/icons/close-fullpage-popup.svg"));

var _druvaLogo = _interopRequireDefault(require("../assets/icons/druva-logo.svg"));

var _druvaLogoOrange = _interopRequireDefault(require("../assets/icons/druva-logo-orange.svg"));

var _globalMenu = _interopRequireDefault(require("../assets/icons/global-menu.svg"));

var _globalMenuHover = _interopRequireDefault(require("../assets/icons/global-menu-hover.svg"));

var _greenTick = _interopRequireDefault(require("../assets/icons/green-tick.svg"));

var _help = _interopRequireDefault(require("../assets/icons/help.svg"));

var _menuClose = _interopRequireDefault(require("../assets/icons/menu-close.svg"));

var _search = _interopRequireDefault(require("../assets/icons/search.svg"));

var _sort = _interopRequireDefault(require("../assets/icons/sort.svg"));

var _userProfile = _interopRequireDefault(require("../assets/icons/user-profile.svg"));

var _wizardArrow = _interopRequireDefault(require("../assets/icons/wizard-arrow.svg"));

var _cal = _interopRequireDefault(require("../assets/icons/cal.svg"));

var _hamburger = _interopRequireDefault(require("../assets/icons/hamburger.svg"));